import React from "react";
import "../Styles/Complete.css";
import { FaBolt, FaShieldAlt, FaCogs, FaMicrochip, FaChartLine, FaSlidersH, FaRoad, FaBuilding } from 'react-icons/fa';

import img1 from "../../Asserts/our1.png";
import img2 from "../../Asserts/our2.png";
import img3 from "../../Asserts/our3.png";
import img4 from "../../Asserts/our4.png";
import img5 from "../../Asserts/our5.png";
import img6 from "../../Asserts/our6.png";
import img7 from "../../Asserts/our7.png";
import img8 from "../../Asserts/our8.png";

const products = [
  { title: "LOW VOLTAGE PANELS – SIVACON S8", img: img1, icon: <FaBolt />,
    points: ["Siemens innovation & technology", "Maximum reliability in protection", "Suited for arduous site conditions", "Compact and space saving"] },
  { title: "LOW VOLTAGE PANELS – LEGACY", img: img2, icon: <FaShieldAlt />,
    points: ["Panels that embody legacy of excellence", "Design flexibility to application needs", "Lower lead time"] },
  { title: "LOW VOLTAGE PANELS – MODULAR", img: img3, icon: <FaCogs />,
    points: ["Modular fully bolt-on design", "Lowest fabrication time", "Improved safety", "Compatible with clean agent systems"] },
  { title: "MEDIUM VOLTAGE 11kV–33kV PANELS", img: img4, icon: <FaMicrochip />,
    points: ["Modular and compact", "Fully compartmentalized construction", "IP2X & IP5X protection", "SCADA + remote operation"] },
  { title: "POWER QUALITY PANELS", img: img5, icon: <FaChartLine />,
    points: ["Modular APF/SVG construction", "Common control for active & passive filters", "Independent module operation", "Expandability & lowest cost"] },
  { title: "VFD & AUTOMATION PANELS", img: img6, icon: <FaSlidersH />,
    points: ["Standalone and lineup panels", "Changeover panels", "Choice of switchgears and drives", "Up to IP65 heat dissipation"] },
  { title: "BUS BAR TRUNKING", img: img7, icon: <FaRoad />,
    points: ["OE manufactured sandwich type", "Seamless integration with panels", "50kA-1sec short-circuit withstand", "Ingress protection up to IP55"] },
  { title: "COMPACT SUB-STATION", img: img8, icon: <FaBuilding />,
    points: ["IEC 62271-202 compliant", "Walk-in and non-walk-in options", "Custom design, maintenance friendly", "Enhanced monitoring & automation"] },
];

const Complete = () => {
  return (
    <div className="products-section">
      <div className="products-header">
        <h2>Our <span className="highlight-orange">Products</span></h2>
        <p>Premium electrical panels and solutions engineered for reliability, safety, and performance.</p>
      </div>
      <div className="products-grid">
        {products.map((product, index) => (
          <div key={index} className="product-card">
            <div className="product-img-wrap">
              <img src={product.img} alt={product.title} />
              <div className="product-icon-badge">{product.icon}</div>
            </div>
            <div className="product-info">
              <h3>{product.title}</h3>
              <ul>
                {product.points.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Complete;
